// 获取环境前缀
export const getEnvPrefix = () => {
    return new URL(window.location.href).host.match(/^(temp|test|uat|pre)?.+/)?.[1] || ''
}
